(function() {
  var SWATCH_UNIT = 25;
  var OVERFLOW_UNIT = 35;
  var MOBILE_BP = 768;
  var MOBILE_MAX_SWATCHES = 5;

  // Inject swatch styles once
  var style = document.createElement('style');
  style.textContent = '.color-swatch--active{box-shadow:0 0 0 1.5px #000;transform:scale(1.15);}'
    + '.grid-product__content:has(.grid-product__colors:hover) .grid-product__secondary-image{opacity:0!important;visibility:hidden!important;}';
  document.head.appendChild(style);

  function calcLimit(container, total) {
    var w = container.getBoundingClientRect().width;
    if (w <= 0) return 0;
    var fit = Math.floor((w - OVERFLOW_UNIT) / SWATCH_UNIT);
    if (window.innerWidth < MOBILE_BP) {
      fit = Math.min(fit, MOBILE_MAX_SWATCHES);
    }
    return fit;
  }

  function swapImage(swatch, hoverImg) {
    var gridProduct = swatch.closest('.grid-product__content');
    if (!gridProduct) return;
    var img = gridProduct.querySelector('.grid-product__image-mask img');
    if (!img) return;
    if (!img.dataset.originalSrc) {
      img.dataset.originalSrc = img.src;
      img.dataset.originalSrcset = img.srcset || '';
    }
    img.src = hoverImg;
    img.srcset = '';
    var sec = gridProduct.querySelector('.grid-product__secondary-image img');
    if (sec) {
      if (!sec.dataset.originalSrc) {
        sec.dataset.originalSrc = sec.src;
        sec.dataset.originalSrcset = sec.srcset || '';
      }
      sec.src = hoverImg;
      sec.srcset = '';
    }
  }

  function restoreImage(swatch) {
    var gridProduct = swatch.closest('.grid-product__content');
    if (!gridProduct) return;
    var img = gridProduct.querySelector('.grid-product__image-mask img');
    if (!img || !img.dataset.originalSrc) return;
    img.src = img.dataset.originalSrc;
    img.srcset = img.dataset.originalSrcset;
    var sec = gridProduct.querySelector('.grid-product__secondary-image img');
    if (sec && sec.dataset.originalSrc) {
      sec.src = sec.dataset.originalSrc;
      sec.srcset = sec.dataset.originalSrcset;
    }
  }

  function handleSwatchClick(e) {
    e.preventDefault();
    var swatch = this;
    var gridProduct = swatch.closest('.grid-product__content');
    if (!gridProduct) return;

    // Update product link to variant URL
    var link = gridProduct.querySelector('a.grid-product__link');
    if (link) link.href = swatch.href;

    // Swap main image to the variant's first image
    var variantImg = swatch.dataset.variantImg;
    if (variantImg) {
      var img = gridProduct.querySelector('.grid-product__image-mask img');
      if (img) {
        img.src = variantImg;
        img.srcset = '';
        img.dataset.originalSrc = variantImg;
        img.dataset.originalSrcset = '';
      }
    }

    // Update secondary (product-hover) image to this color's hover image
    var hoverImg = swatch.dataset.hoverImg;
    var sec = gridProduct.querySelector('.grid-product__secondary-image img');
    if (sec && hoverImg) {
      sec.src = hoverImg;
      sec.srcset = '';
      sec.dataset.originalSrc = hoverImg;
      sec.dataset.originalSrcset = '';
    }

    // Mark active swatch
    var allSwatches = gridProduct.querySelectorAll('.color-swatch');
    for (var i = 0; i < allSwatches.length; i++) {
      allSwatches[i].classList.remove('color-swatch--active');
    }
    swatch.classList.add('color-swatch--active');
  }

  var observer = new IntersectionObserver(function(entries) {
    for (var i = 0; i < entries.length; i++) {
      if (!entries[i].isIntersecting) continue;
      var container = entries[i].target;
      observer.unobserve(container);

      var data;
      try {
        data = JSON.parse(container.getAttribute('data-swatch-data'));
      } catch (e) {
        continue;
      }
      if (!data || !data.length) continue;

      var total = data.length;
      var limit = 0;
      if (container.hasAttribute('data-swatch-limit')) {
        var autoLimit = container.getAttribute('data-swatch-limit') === 'auto';
        if (autoLimit) {
          var maxFit = Math.floor(container.getBoundingClientRect().width / SWATCH_UNIT);
          var isMobile = window.innerWidth < MOBILE_BP;
          limit = (total > maxFit || isMobile) ? calcLimit(container, total) : 0;
        } else {
          limit = parseInt(container.getAttribute('data-swatch-limit'), 10) || 0;
        }
      }
      var renderCount = (limit > 0 && total > limit) ? limit : total;

      var frag = document.createDocumentFragment();
      for (var j = 0; j < renderCount; j++) {
        var s = data[j];
        var a = document.createElement('a');
        a.href = s.url;
        a.className = 'color-swatch color-swatch--small';
        a.setAttribute('aria-label', s.label);
        a.style.cssText = 'background-color:' + s.bg + ';' + (s.img ? 'background-image:url(' + s.img + ');' : '') + 'border-radius:20px;';
        if (s.variantImg) a.dataset.variantImg = s.variantImg;
        if (s.hoverImg) a.dataset.hoverImg = s.hoverImg;
        a.addEventListener('click', handleSwatchClick);
        frag.appendChild(a);
      }

      if (limit > 0 && total > limit) {
        var overflow = document.createElement('a');
        overflow.className = 'swatch-overflow';
        overflow.href = data[0].url.split('?')[0];
        overflow.textContent = (total - limit) + '+';
        frag.appendChild(overflow);
      }

      container.appendChild(frag);
      container.removeAttribute('data-swatch-data');
    }
  }, { rootMargin: '200px' });

  function init() {
    var containers = document.querySelectorAll('[data-swatches-lazy]');
    for (var i = 0; i < containers.length; i++) {
      observer.observe(containers[i]);
    }

    // Tiles can arrive after initial load (merchandising page-merge, AJAX
    // filtering) — observe their swatch containers as they're added. Already
    // rendered containers re-observed here no-op via the empty-data guard.
    var root = document.getElementById('CollectionAjaxContent') || document.body;
    new MutationObserver(function(mutations) {
      for (var m = 0; m < mutations.length; m++) {
        var added = mutations[m].addedNodes;
        for (var n = 0; n < added.length; n++) {
          var node = added[n];
          if (node.nodeType !== 1) continue;
          if (node.hasAttribute && node.hasAttribute('data-swatches-lazy')) {
            observer.observe(node);
          }
          if (node.querySelectorAll) {
            var nested = node.querySelectorAll('[data-swatches-lazy]');
            for (var q = 0; q < nested.length; q++) {
              observer.observe(nested[q]);
            }
          }
        }
      }
    }).observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
